import { Typography, useModal } from '@aloft/toolkit-sui';

export const useDeleteOrderModal = (address: string, deleteOrder: () => void) => {
  const { Modal, openModal, isModalOpen, closeModal } = useModal();

  const DeleteOrderModal = isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      onClose={closeModal}
      primaryAction={{
        text: 'Delete Order',
        onClick: deleteOrder,
      }}
      secondaryAction={{ text: 'Cancel', onClick: closeModal }}
    >
      <Typography variant="h1">Confirm Order Deletion</Typography>
      <Typography variant="body1">{`Are you sure you want to delete the order for ${address}? This action cannot be undone.`}</Typography>
    </Modal>
  ) : null;
  return { Modal: DeleteOrderModal, openModal };
};
